var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Tooltip } from '@robinpowered/ui-kit';
import { useWatch } from 'react-hook-form';
import { DateTimePicker } from './DateTime/DateTimePicker';
import { Recurrence } from './DateTime/Recurrence';
import { RecurrenceSummary } from './DateTime/RecurrenceSummary';
import { ComposerMode, } from '../types/index';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimeSuggestionsContainer } from './DateTime/TimeSuggestions';
import { PreConfirmCheckbox } from './DateTime/PreConfirmCheckbox';
import { useApprovedRequestFieldsLocked } from '../hooks/useApprovedRequestFieldsLocked';
export var DateTimeWrapper = function (_a) {
    var _b;
    var requestOnlySpace = _a.requestOnlySpace, showRecurrence = _a.showRecurrence, initialEvent = _a.initialEvent;
    var t = useTranslation('meetingRooms').t;
    var _c = useEventComposerGlobalContext(), timezone = _c.timezone, timeFormat = _c.timeFormat, composerMode = _c.composerMode;
    var _d = __read(useWatch({
        name: ['spaceBuffers', 'recurrenceRule'],
    }), 2), spaceBuffers = _d[0], recurrenceRule = _d[1];
    var _e = __read(useState(false), 2), showAdvancedOptions = _e[0], setShowAdvancedOptions = _e[1];
    var disableDatePicker = useApprovedRequestFieldsLocked(requestOnlySpace, (_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.reservationApproval) === null || _b === void 0 ? void 0 : _b.approved);
    var toggleAdvancedOptions = function () {
        setShowAdvancedOptions(!showAdvancedOptions);
    };
    return (_jsxs(Wrapper, { children: [_jsx(Tooltip, { title: spaceBuffers
                    ? t('buffers.buffer_disallow.recurring_event')
                    : undefined, children: _jsx(ShowMoreLink, { type: "link", onClick: toggleAdvancedOptions, children: showAdvancedOptions
                        ? t('advanced_options.show_less')
                        : t('advanced_options.show_more') }) }), _jsxs(Flex, { vertical: true, gap: 8, children: [_jsx(DateTimePicker, { disabled: disableDatePicker, timezone: timezone, timeFormat: timeFormat, disallowPastStart: composerMode === ComposerMode.CREATE, hasBuffers: !!spaceBuffers, showAdvancedOptions: showAdvancedOptions, recurrenceSlot: showAdvancedOptions ? (_jsx(Recurrence, { disabled: disableDatePicker, showRecurrence: showRecurrence && showAdvancedOptions })) : (_jsx(RecurrenceSummary, { rule: recurrenceRule })) }), _jsx(PreConfirmCheckbox, { disabled: disableDatePicker }), !disableDatePicker && _jsx(TimeSuggestionsContainer, {})] })] }));
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ShowMoreLink = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  height: 22px;\n  padding: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  height: 22px;\n  padding: 0;\n"])));
var templateObject_1, templateObject_2;
